import classNames from "classnames";
import React from "react";

import "./formTitle.scss";

export const FormTitle = ({ children, className }) => {
  return <h3 className={classNames("form-title", className)}>{children}</h3>;
};
